export enum DrawerType {
  TaskDrawer = 'task',
  AdhocTaskDrawer = 'adhocTask',
  EditAdhocTaskDrawer = 'editAdhocTask',
  Integration = 'integration',
  RejectComment = 'rejectComment',
}
